import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  HostBinding,
  Renderer2,
  effect,
  inject,
  input
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { pxToRem } from '@pc/shared';
import { PcImages } from '@pc/common';

@Component({
  selector: 'pc-background-main-image',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './background-main-image.component.html',
  styleUrl: './background-main-image.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BackgroundMainImageComponent {
  public renderer2 = inject(Renderer2);
  public hostElement = inject(ElementRef).nativeElement;
  public image = input.required<string>();
  public borderRadius = input<number>(0);
  protected readonly PcImages = PcImages;

  constructor() {
    effect(() => this.handleImageChange());
  }

  @HostBinding('style.--border-radius') get borderRadiusStyle() {
    return pxToRem(this.borderRadius()) + 'rem';
  }

  private handleImageChange() {
    if (!this.image()) {
      return;
    }
    const img: HTMLImageElement = this.renderer2.createElement('img');
    img.onload = () => {
      this.renderer2.addClass(img, 'loaded');
      setTimeout(() => this.renderer2.removeChild(this.hostElement, this.hostElement.firstChild), 200);
    };
    this.renderer2.addClass(img, 'background-image');
    this.renderer2.setAttribute(img, 'src', this.image());
    this.renderer2.setAttribute(img, 'alt', '');
    this.renderer2.appendChild(this.hostElement, img);
  }
}
